<template>
  <div class="inline phone" :class="{TA:isTestAchat}">
    <v-select
      class="select tel"
      :options="options"
      :searchable="false"
      :components="{Deselect}"
      :reduce="options => options.value"
      label="value"
      v-model="value.prefix"
    >
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">{{ option.value }}</div>
      </template>
       <template slot="option" slot-scope="option">
        <div class="option d-center">
          <img class="icon" :src="require(`@/assets/flags/${option.flag}.png`)" />
          {{ option.value }}
        </div>
      </template>
    </v-select>
    <input
      name="phone"
      class="input"
      :class="[prefix ? 'phone': '']"
      type="tel"
      :placeholder="placeholder"
      @blur="$emit('blur')"
      v-bind:value="value.number"
      v-on:input="format($event.target.value)"
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      prefix: "+32",
      options: [
        { flag: "be", value: "+32" },
        { flag: "fr", value: "+33" },
        { flag: "nl", value: "+31" },
        { flag: "es", value: "+34" },
        { flag: "lu", value: "+352" },
        { flag: "it", value: "+39" },
        { flag: "sui", value: "+41" },
        { flag: "gb", value: "+44" },
        { flag: "po", value: "+48" },
        { flag: "de", value: "+49" },
      ],
    };
  },
  computed: {
    ...mapGetters("subscription", ["isTestAchat"]),
    Deselect() {
      return null;
    },
  },
  props: {
    value: {
      type: Object,
    },
    placeholder: {
      type: String,
      required: false,
      default: "000000000",
    },
  },
  methods: {
    format(value) {
      this.value.type = 'mobile'

      if(this.prefix === '+32') {
        let mobile = value.match("^((\\+|00|)32\\s?|0|)4(5[56]|60|[6789]\\d)(\\s?\\d{2}){3}$");
        let fix = value.match("^((\\+|00|)32\\s?|0|)(\\d(\s)?\\d{3}|\\d{2}(\s)?\\d{2})((\\s)?\\d{2}){2}$");
        if(mobile) {
          value = value.replace(mobile[1], "");
        }
        else if(fix) {
          this.value.type = 'phone'
          value = value.replace(fix[1], "");
        }
      }
      else {

      }

      this.value.number = value;

      this.$emit('input', this.value);
    },
  },
  components: {
    vSelect,
  },
};
</script>

<style lang="scss" scoped>
.select {
  flex: 0 0 auto;
  align-self: stretch;

  /deep/ &.tel .vs__dropdown-toggle{
    cursor: pointer!important;
    border: 2px solid $yellow!important;
    border-right: 0!important;

    .vs__selected-options {
      margin: 0!important;
      padding: 0!important;

      .vs__selected {
        margin: 0!important;
        padding: 0!important;
      }
    }
  }
}

input.input.phone {
  width: auto;
  min-width: 100px;
  flex: 1!important;
  border-radius: 0px 4px 4px 0px !important;
  border-left: 0!important;
}

/deep/ .select .vs__dropdown-toggle {
  border: 0;
  font-family: "ObjectSans", Helvetica, Arial, sans-serif;
  font-size: 0.95rem;
  padding: 0;
  // padding: 5px 10px;
  border-radius: 4px 0px 0px 4px;
  border: 2px solid $yellow;
  border-left: 0;
  background: $clearYellow;
  width: 85px;
  height: 100%;

  .vs__search {
    height: 0;
  }

  .selected {
    position: relative;
    padding: 0!important;
    margin-left: 2px;
  }
}

/deep/ .vs--open {
  .vs__selected {
    position: relative!important;
  }
}


/deep/ .vs__dropdown-menu {
  min-width: 85px;
  width: 105px;
}

.option {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .icon {
    height: 1rem;
  }
}

.TA {
  .select {
    /deep/ &.tel .vs__dropdown-toggle{
      border: 2px solid $pink!important;
    }
  }

  /deep/ .select .vs__dropdown-toggle {
    font-family: "Lato", Helvetica, Arial, sans-serif;
    border: 2px solid $pink!important;
    background: $pink;

    .vs__selected-options {
      span {
        color: $white!important;
      }
    }

    .vs__actions>svg {
        fill: $white;
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Form/BecomeFields/PhoneField.vue